module.exports = __webpack_public_path__ + "static/media/roger.3ed6582c.png";